import {Analytics} from '../core/Analytics';
import {AnalyticsConfig} from '../types/AnalyticsConfig';
import {CustomDataValues} from '../types/CustomDataValues';
import {logger} from '../utils/Logger';

import {InternalAdapterAPI} from './internal/InternalAdapterAPI';

export abstract class Adapter {
  protected analytics!: Analytics;
  protected internalAdapter!: InternalAdapterAPI;

  getCurrentImpressionId(): string | undefined {
    if (!this.guardAgainstNotInitializedAnalytics()) {
      return;
    }
    return this.analytics.getCurrentImpressionId();
  }

  getUserId(): string | undefined {
    if (!this.guardAgainstNotInitializedAnalytics()) {
      return undefined;
    }
    return this.analytics.getUserId();
  }

  setCustomData(values: CustomDataValues) {
    if (!this.guardAgainstNotInitializedAnalytics()) {
      return;
    }
    this.internalAdapter.setCustomData(values);
  }

  setCustomDataOnce(values: CustomDataValues) {
    if (!this.guardAgainstNotInitializedAnalytics()) {
      return;
    }
    this.analytics.setCustomDataOnce(values);
  }

  sourceChange(config: AnalyticsConfig) {
    if (!this.guardAgainstNotInitializedAnalytics()) {
      return;
    }
    this.analytics.sourceChange(config);
  }

  // Checks if analytics is already initialized on this player instance
  protected hasPlayerAlreadyBeenAugmented(player): boolean {
    return (player as any).__bitmovinAnalyticsHasBeenSetup;
  }
  // Marks the player instance as already instrumented by analytics
  protected markPlayerInstanceAsAugmented(player) {
    (player as any).__bitmovinAnalyticsHasBeenSetup = true;
  }

  protected guardAgainstNotInitializedAnalytics(): boolean {
    if (!this.analytics) {
      logger.log("Bitmovin Analytics: Adapter hasn't been initialized yet");
      return false;
    }
    return true;
  }
}
